<template>
    <NuxtLink
        :to="isMounted && account().isLoggedIn ? localePath('/account') : localePath('/login')"
        class="flex flex-col items-center justify-center space-y-1 overflow-hidden transition-opacity lg:flex-row lg:space-x-1 lg:space-y-0 lg:hover:opacity-70"
        :class="{ 'text-primary': isAuthPage }"
        @click="mobileNav().close()">
        <Icon :icon="IconUserCircle" class="block text-2xl text-inherit" :auto-align="false" />
        <span class="max-w-[8ch] truncate text-xxs font-bold uppercase leading-none lg:text-sm">{{ isMounted && account().isLoggedIn ? userName : 'account' }}</span>
    </NuxtLink>
</template>

<script lang="ts" setup>
    import IconUserCircle from '@/assets/icons/user-circle.svg'
    import Icon from '~/components/Icon.vue'
    import { account } from '~/store/account'
    import { mobileNav } from '~/store/mobileNav'
    const localePath = useLocalePath()
    const route = useRoute()
    const isMounted = ref(false)
    const authPaths = [
        '/account',
        '/login',
        '/forgot-password',
        '/register',
        '/resend-verify-email',
        '/reset-password'
    ]
    const isAuthPage = computed(() => {
        return authPaths.some(path => route.fullPath.includes(path))
    })
    const userName = computed(() => account().userData?.customer?.firstName || account().email || 'account')
    onMounted(async () => {
        isMounted.value = true
    })
</script>
